import { cn } from '@/lib/cn';

// Actual EcRegi seal (source: /screen-ss/ecregi_logo.png, copied into /public).
export function EcregiSeal({ className, size = 72 }: { className?: string; size?: number }) {
  return (
    <img
      src="/ecregi_logo.png"
      alt="EcRegi"
      width={size}
      height={size}
      className={cn('select-none', className)}
      draggable={false}
    />
  );
}
